@let copy = maintenanceCopy$ | async;
<lib-maintenance-shell
    [maintenance$]="maintenance$"
    logoSrc="./assets/images/cargosprint/logo-cargosprint-horizontal-color.webp"
    logoAlt="CargoSprint"
    [badgeLabel]="copy?.badgeLabel ?? 'Scheduled Maintenance'"
    [title]="copy?.title ?? ''"
    [appName]="copy?.appName ?? ''"
    [message]="copy?.message ?? ''"
    [dateValue]="copy?.dateValue ?? ''"
    [statusValue]="copy?.statusValue ?? ''"
    [returnValue]="copy?.returnValue ?? ''"
    [footerText]="copy?.footerText ?? ''"
    [contactUrl]="copy?.contactUrl ?? ''"
>
    <div>
        <router-outlet />
    </div>
</lib-maintenance-shell>
